<template>
  <div class="container">
    <h1 class="mb-4">{{ promoter.fullname }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#investors">
              <fai icon="address-book"/>&nbsp;Acreedores
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#commissions">
              <fai icon="dollar-sign"/>&nbsp;Comisiones
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#payments">
              <fai icon="dollar-sign"/>&nbsp;Pagos
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="promoter.promoters_id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-info" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6 col-md-4">
                  <h5>Correo electrónico</h5>
                  <span>{{ promoter.email }}</span>
              </div>
              <div class="col-sm-6 col-md-4">
                  <h5>Teléfono</h5>
                  <span>{{ promoter.telephone }}</span>
              </div>
              <div class="col-sm-6 col-md-4">
                  <h5>Celular</h5>
                  <span>{{ promoter.mobile }}</span>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 col-md-4">
                    <h5>Fecha de nacimiento</h5>
                    <span>{{ promoter.dob | reverseDate }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>CURP</h5>
                    <span>{{ promoter.curp }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>Tipo</h5>
                    <span>{{ promoter.type }}</span>
                </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6 col-md-4">
                <h5>Comisión</h5>
                <span>{{ promoter.comision }}%</span>
              </div>
              <div class="col-sm-6 col-md-4">
                  <h5>Aplica Intereses</h5>
                  <span>{{ (promoter.comision_interest) ? 'Sí' : 'No' }}</span>
              </div>
              <div class="col-sm-6 col-md-4">
                  <h5>Nacionalidad</h5>
                  <span>{{ promoter.nationality }}</span>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Datos fiscales</h4>
                </div>
            </div>
            <div class="row mt-4" v-if="fiscal_address">
                <div class="col-sm-6 col-md-4">
                    <h5>RFC</h5>
                    <span>{{ fiscal_address.rfc }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>Calle</h5>
                    <span>{{ fiscal_address.street }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>Número ext./int.</h5>
                    <span>{{ fiscal_address.number }}</span>
                </div>
            </div>
            <div class="row mt-4" v-if="promoter.fiscal_address">
                <div class="col-sm-6 col-md-4">
                    <h5>Colonia</h5>
                    <span>{{ fiscal_address.neighborhood }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>Municipio</h5>
                    <span>{{ fiscal_address.city }}</span>
                </div>
                <div class="col-sm-6 col-md-4">
                    <h5>Estado</h5>
                    <span>{{ fiscal_address.state }}</span>
                </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col">
                    <h4 class="m--font-info">Datos Bancarios</h4>
                </div>
            </div>
            <div class="row mt-4" v-if="bank_data">
                <div class="col-sm-6 col-md-3">
                    <h5>Cuentahabiente</h5>
                    <span>{{ promoter.bank_data.holder }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Banco</h5>
                    <span>{{ promoter.bank_data.bank }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Número de cuenta</h5>
                    <span>{{ promoter.bank_data.account }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>CLABE</h5>
                    <span>{{ promoter.bank_data.clabe }}</span>
                </div>
            </div>
          </div>
          <!--end: Details -->
          <!--begin: Investmentors -->
          <div id="investors" class="tab-pane fade" role="tabpanel" v-if="promoter.id">
            <sys-table :headers="investors_headers" :items="investors" title="Acreedores" error_message="No se encontraron acreedores" detail_route="investor" :title_icon="['far','file']"/>
          </div>
          <!--end: Investmentors -->
          <!--begin: Commissions -->
          <div id="commissions" class="tab-pane fade" role="tabpanel" v-if="promoter.promoters_id">
            <sys-table :headers="commissions_headers" :items="commissions" title="Comisiones" :create_route="comision_create" :create_route_params="comision_create_params" error_message="No se encontraron comisiones" :detail_route="comision_detail" title_icon="dollar-sign"/>
          </div>
          <!--end: Commissions -->
          <!--begin: Payments -->
          <div id="payments" class="tab-pane fade" role="tabpanel" v-if="promoter.promoters_id">
            <sys-table :headers="payments_headers" :items="payments" title="Pagos" :create_route="payment_create" :create_route_params="payment_create_params" error_message="No se encontraron pagos" :detail_route="payment_detail" title_icon="dollar-sign"/>
          </div>
          <!--end: Payments -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banksService from '@/services/banks'
import PromotersService from '@/services/promoters'
import SysTable from '@/components/shared/Table'
import formatCurrency from '@/filters/formatCurrency'

export default {
  components: { SysTable },

  data () {
    return {
      payment_create: 'payment_create',
      payment_create_params: {
        promoter_id: this.$route.params.id
      },
      payment_detail: 'payment',
      comision_create: 'comision_create',
      comision_create_params: {
        promoter_id: this.$route.params.id
      },
      comision_detail: 'comision',
      promoter: {},
      investors_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'fullname' },
        { text: 'Monto de inversión', value: 'investments_amount', filter: formatCurrency },
        { text: 'Inversiones', value: 'investments_count' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Tipo', value: 'type' }
      ],
      investors: [],
      fiscal_address: [],
      bank_data: [],
      commissions_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Fecha Inicio', value: 'date_init' },
        { text: 'Fecha Fin', value: 'date_end' },
        { text: 'Anexos', value: 'attachments' },
        { text: 'Anexos Intereses', value: 'monthly_cut_attachments' },
        { text: 'Comisión', value: 'amount', filter: formatCurrency },
        { text: 'Pagado', value: 'payed', filter: formatCurrency },
        { text: 'Por Pagar', value: 'pending', filter: formatCurrency }
      ],
      commissions: [],
      payments_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Id Comisión', value: 'comision_id' },
        { text: 'Anexo', value: 'attach_id' },
        { text: 'Anexo Intereses', value: 'monthly_attach_id' },
        { text: 'Fecha', value: 'date_payment' },
        { text: 'Monto', value: 'amount', filter: formatCurrency },
        { text: 'IVA', value: 'iva_amount', filter: formatCurrency },
        { text: 'Total', value: 'total_amount', filter: formatCurrency },
        { text: 'Comprobante', value: 'file_url', link: true, class: 'text-center' }
      ],
      payments: []
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id
    let element = this.$store.getters.getSelectedElement

    if (element.type === 'promoter' && element.data.id === id) this.promoter = element.data
    else {
      PromotersService.getById(id).then(res => {
        this.promoter = res.data
        this.investors = res.data.investors
        this.fiscal_address = res.data.fiscal_address
        this.bank_data = res.data.bank_data
        banksService.list().then(res => {
          this.bank_ids = res.map(bank => {
            if (this.promoter.bank_data) {
              if (bank.id == this.promoter.bank_data['bank_id']) {
                this.promoter.bank_data.bank = bank.name
              }
            }
            return bank.id
          })
        })
      })
    }
  },
  created: function () {
    const id = this.$route.params.id
    PromotersService.listComisions(id).then(res => {
      this.commissions = res.data
    })
    PromotersService.listPayments(id).then(res => {
      this.payments = res.data
    })
  },
  methods: {
    goToEdit () {
      const id = this.$route.params.id
      this.$router.push({ name: 'promoter_update', params: { id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/PromoterDetail.vue